import React from "react";
import { Box, Heading, Text, Image, Container, SimpleGrid, VStack, useColorModeValue } from "@chakra-ui/react";

function About() {
  const bgColor = useColorModeValue("brand.cream", "brand.navy");
  const textColor = useColorModeValue("brand.dark", "brand.cream");
  const valuesBgColor = useColorModeValue("brand.green", "brand.dark");
  const valueItemBgColor = useColorModeValue("brand.cream", "brand.navy");
  const valueItemHeadingColor = useColorModeValue("brand.green", "brand.orange");


  const valuesWithText = [
    { value: "Commitment", text: "Our commitment to excellence drives us to provide employee training, equipping them to meet industry demands and exceed client expectations" },
    { value: "Responsibility", text: "Taking responsibility in our roles builds trust within the company and with our clients, ensuring that our services meet the highest safety and efficiency standards." },
    { value: "Consistency", text: "Daily dedication to our work drives us toward excellence. Our commitment to continuous improvement to maintain the highest service quality." },
    { value: "Teamwork", text: "Collaboration is key to achieving outstanding results. For instance, our project teams work closely with clients, subcontractors, and suppliers to ensure seamless communication and coordination." },
    { value: "Skill", text: "We regularly update our team's knowledge on the latest advancements in solar technology and energy-efficient building materials, enabling us to offer cutting-edge solutions to our clients." },
    { value: "Employees", text: "Our employees are not just a part of our organization; they are the foundation for our success. Moreover, we believe in treating our employees with the same care, respect, and  consideration we offer our customers." },
  ];

  return (
    <Box py={20} bg={bgColor}>
      <Container maxW={"container.xl"}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          <VStack align={"flex-start"} spacing={5}>
            <Heading as="h1" size="2xl">
              About Satoal
            </Heading>
            <Text fontSize={"lg"} color={textColor}>
            SATOAL® is a Spanish company based in Seville, established two years ago. Backed by a team with over 20 years of experience, we are committed to delivering excellence through our wide range of services, ensuring complete client satisfaction.
            </Text>
            <Text fontSize={"lg"} color={textColor}>
              At SATOAL®, we take full responsibility for recruiting and training personnel in firm adherence
              to our client's instructions and policies. Our internal supervisors continuously monitor and
              guarantee the quality of services provided.
            </Text>
          </VStack>
          <Box>
            <Image src="/path-to-about-image.jpg" alt="Satoal Team" borderRadius="md" />
          </Box>
        </SimpleGrid>

        <Box mt={20} bg={valuesBgColor} p={10} borderRadius="md">
          <Heading as="h2" size="xl" mb={10} textAlign="center" color="brand.cream">
            Our Values
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
            {valuesWithText.map((item) => (
              <VStack key={item.value} align={"center"} bg={valueItemBgColor} p={5} borderRadius="md">
                <Heading as="h3" size="md" color={valueItemHeadingColor}>
                  {item.value}
                </Heading>
                <Text textAlign="center" color={textColor} >
                  {item.text}
                </Text>
              </VStack>
            ))}
          </SimpleGrid>
        </Box>
      </Container>
    </Box>
  );
}

export default About;
